<template>
  <div class="grace-period-banner">
    <i class="material-icons">warning</i>
    <span>
      Ihr Abo ist abgelaufen. Sie können Daten nur noch ansehen und herunterladen.
      Für weitere Aktionen erwerben Sie bitte ein
      <a href="/produkte" class="shop-link">neues Abo</a>.
    </span>
  </div>
</template>

<style scoped>
.grace-period-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  background-color: #fff3cd;
  border-bottom: 2px solid #f59e0b;
  color: #92400e;
  font-size: 14px;
}

.grace-period-banner .material-icons {
  font-size: 20px;
  color: #f59e0b;
}

.shop-link {
  color: #92400e;
  font-weight: bold;
  text-decoration: underline;
}
</style>
